module.exports = __webpack_public_path__ + "img/co-o.b2bc3657.svg";